import { z } from "zod";
import type { TFunction } from "i18next";

export const profileSchema = (t: TFunction) =>
  z.object({
    username: z
      .string()
      .min(5, t("validationUsernameMinLength"))
      .max(20, t("validationUsernameMaxLength")),
    email: z.string().email(t("validationInvalidEmail")),
    password: z.optional(z.string()),
    isShowLeaderBoard: z.boolean(),
    image: z.instanceof(File).optional(),
  });

export type ProfileFormData = z.infer<ReturnType<typeof profileSchema>>;

export interface ProfileType {
  id?: string;
  username: string;
  email: string;
  password: string;
  role: string;
  profilePicture?: string;
  isShowLeaderBoard: boolean;
}
